'use strict';

function _AccountController() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_Secured, _ErrorController, _AccountActions, _CryptoActions, _OnboardingCoordinator];

  // State of the Page
  this.validated = null;

  this.init = function () {
    this._super();

    this.history = new History();

    this.initOnboardingCoordinator(); // _OnboardingCoordinator
  };

  this.initAllReady = function () {
    this._super();

    this.checkPagePrerequisites();

    this.presenter.addCallbackToAction('account.self', this.updateAccountState.bind(this));
  };

  this.checkPagePrerequisites = function () {
    // check if user has passed the pages prerequisites
    // if not, route them to the appropriate page

    // previously:
    // this.validated = this._validatePageRequest();

    var _hasCommonPreReqs = this.hasDoneCreditCheck() && this.hasValidVerificationLevel() && this.hasAllProfileInfo() && this.hasProvidedConsent(); // Phase 1 mimic old security system

    // downgrade security on a per page/section basis:
    // Phase 1 we can group all pages and then specify checks on page level
    // Phase 2 add specific page checks to availableSteps obj
    var isOnboardingPage = window.location.href.indexOf('/onboarding/') !== -1 || window.location.href.indexOf('/dashboard/declined/') !== -1 || window.location.pathname === this.paths.signup.create_profile || window.location.pathname === this.paths.signup.create_profile_step2 || window.location.pathname === '/member/dashboard/profile-info-deprecated' || window.location.pathname === this.paths.signup.kyc_questions || window.location.pathname === this.paths.signup.kyc_partner_down || window.location.pathname === this.paths.signup.account_already_exists || window.location.pathname === this.paths.signup.credit_check;

    if (isOnboardingPage) {
      // downgrade prerequisites if credit check not completed yet
      // onboarding pages handle additional checks and routing in their init()'s
      _hasCommonPreReqs = this.hasVerifiedEmail();
    }

    // Phase 1: similar to old system...
    // AccountController checks if you have completed all of onboarding (currently checking last step),
    //    ... if not, bounces you backwards.
    // Individual pages check if you should be on that page,
    //    ... if not, bounces you forwards.
    var _hasCompletedProfile = this.presenter.getModelProperty('account.profile_completed_at');
    var _province = this.presenter.getModelProperty('account.province');
    if (!_hasCommonPreReqs) {
      this.routeToNextStep();
      this.validated = false; // existing shorting system
    } else if (!!_hasCompletedProfile && _province === 'QC') {
      // for TradeApp users from Quebec who have have fully completed onboarding, allow them to view account settings page only.
      this.history.goToUrl(this.paths.account.settings);
    } else {
      this.validated = true;
    }
  };

  this.updateAccountState = function () {
    mogo.registry.mogoUI.repo.Portal.branchSetIdentity();
    // window.mogo.registry.mogoUI.appState.dispatch(this.accountReady(this.presenter.models.account));
  };

  this.handleDeclinedState = function (data, response) {
    var currentPath = window.location.pathname;
    if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage({
        action: 'account.create_kyc_questions',
        data: { device_print: '' }
      }, { productLabel: 'MogoMember' }, $.proxy(this.handleDeclinedState, this));
    } else if (response == 200) {
      if (data.kyc_decision == 'declined' && data.kyc_attempts === 0 || data.kyc_decision === 'permanently_failed') {
        if (currentPath != this.paths.signup.declined.kyc_failed) {
          this.history.goToUrl(this.paths.signup.declined.kyc_failed);
        }
      } else if (data.kyc_decision == 'profile_not_found') {
        if (currentPath != this.paths.signup.declined.profile_not_found) {
          this.history.goToUrl(this.paths.signup.declined.profile_not_found);
        }
      } else {
        // this is the success case so redirect them to the kyc question path
        if (currentPath != this.paths.signup.kyc_questions) {
          this.history.goToUrl(this.paths.signup.kyc_questions);
        }
      }
    } else {
      switch (data.errors[0].key) {
        case 'equifax_remote_service_error':
          this.history.goToUrl(this.paths.signup.unrecoverable_error);
          break;
        case 'member_service_underage_and_province_exception':
          this.history.goToUrl(this.paths.signup.declined.province_underage);
          break;
        case 'member_service_invalid_province':
          this.history.goToUrl(this.paths.signup.declined.province);
          break;
        case 'member_service_underage_exception':
          this.history.goToUrl(this.paths.signup.declined.underage);
          break;
        default:
          $('#Notification').mogo().get();
          break;
      }
    }
  };

  this.getTimezoneOffset = function () {
    var accountModel = this.presenter.models.account;
    if (accountModel && accountModel.timezone) {
      return accountModel.timezone.split('/').pop().trim();
    }
  };

  // this logic moved from CreditCheck.js so that main dashboard interstitial decisioning can use it too
  this._isLoanOfferCustomer = function (data) {
    var promoCode = new PromoCode();
    return promoCode.exists(this.presenter.models.account) || this._isHotLead() || this._isCreditSeekerWithReferralOffer(data) || this._isPendingThirdPartyDecisioningScore();
  };

  this._isHotLead = function () {
    return this.presenter.getModelProperty('account.credit_seeker_status') === 'hot_lead';
  };

  this._isCreditSeekerWithReferralOffer = function (data) {
    var _interestsArr = this.presenter.getModelProperty('account.products_of_interest');
    return !!_interestsArr && _interestsArr.includes('loan') && data.referral !== null;
  };

  this._isPendingThirdPartyDecisioningScore = function () {
    return this.presenter.getModelProperty('account.credit_check_decision') === 'trust_science_pending';
  };

  this.destroy = function () {
    // Do not remove
    // this._super();
  };
}